import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { SlideUpDown } from "../../../services/script"
import LogoImage from "../headers/common/logo"
import Logo from "../../../assets/logo/ezlogo2.png";
import Enamad from "../../../assets/images/enamad.png";
import Logo2 from "../../../assets/images/logo.png";

class FooterFour extends Component {

    componentDidMount() {
        var contentwidth = window.innerWidth;
        if ((contentwidth) < 750) {
            SlideUpDown('footer-title');
        } else {
            var elems = document.querySelectorAll(".footer-title");
            [].forEach.call(elems, function (elemt) {
                let el = elemt.nextElementSibling;
                el.style = "display: block";
            });
        }
    }
    openWindow() {
        window.open("https://logo.samandehi.ir/Verify.aspx?id=300868&p=xlaoobpdobpdmcsigvkamcsi", "Popup","toolbar=no,scrollbars=no,location=no,statusbar=no,menubar=no,resizable=0,width=450,height=630,top=30");
      }


    render() {

        return (
            <footer className="">
                {/* <div className="white-layout">
                    <div className="container">
                        <section className="small-section">
                            <div className="row">
                                <div className="col-xl-6 offset-xl-3">
                                    <div className="subscribe">
                                        <h4>newsletter</h4>
                                        <form className="form-inline subscribe-form classic-form">
                                            <div className="form-group">
                                                <input type="text" className="form-control" id="exampleFormControlInput"
                                                       placeholder="Enter your email" />
                                            </div>
                                            <button type="submit" className="btn btn-solid">subscribe</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div> */}
                <section className="section-b-space darken-layout">
                    <div className="container">
                        <div className="row footer-theme partition-f">
                        
                            <div className="col-lg-3 col-md-6">
                            <div className="sub-title">
                                <div className="">
                                    <h4>درباره ما</h4>
                                </div>
                                <div className="">
                                    {/* <div className="brand-logo layout2-logo">
                                        <img src={Logo} alt="" className="img-fluid" />
                                    </div> */}
                                    {/* <div className="footer-logo">
                                        <LogoImage logo={this.props.logoName} />
                                    </div> */}
                                    <p>ایزی کارت724 تداعی خلاقیت و نوآوری در دنیای پرداخت های انلاین است ، کیفیت محصولات ، پشتیبانی ویژه و منحصربه فرد از ویژگی های برجسته ایزی کارت می باشد. مجموعه ایزی کارت724 تلاش می‌کند مسیر آسانی برای دسترسی کاربران ایرانی به خدمات ارزی و ارتباطات مالی بین‌المللی فراهم کند و بابت هموارتر کردن مسیر پیشرفت هزاران ایرانی به خود می‌بالد. </p>
                                    {/* <div className="footer-social">
                                        <ul>
                                            <li>
                                                <Link to={'https://www.facebook.com/'} ><i className="fa fa-facebook" aria-hidden="true"></i></Link>
                                            </li>
                                            <li>
                                                <Link to={'https://plus.google.com/'} ><i className="fa fa-google-plus" aria-hidden="true"></i></Link>
                                            </li>
                                            <li>
                                                <Link to={'https://twitter.com'}><i className="fa fa-twitter" aria-hidden="true"></i></Link>
                                            </li>
                                            <li>
                                                <Link to={'https://instagram.com'}><i className="fa fa-instagram" aria-hidden="true"></i></Link>
                                            </li>
                                            <li>
                                                <Link to={'https://rss.com/'}><i className="fa fa-rss" aria-hidden="true"></i></Link>
                                            </li>
                                        </ul>
                                    </div> */}
                                </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 offset-xl-1">
                                <div className="sub-title">
                                    <div className="">
                                        <h4>آخرین مقالات</h4>
                                    </div>
                                    <div className="">
                                        <ul>
                                            <li><Link to={`${process.env.PUBLIC_URL}/blog/details?id=1`} >اتصال اسپاتیفای به اینترنت بدون vpn (فیلترشکن)</Link></li>
                                            <li><Link to={`${process.env.PUBLIC_URL}/blog/details?id=2`}  >چگونه پلی لیست و آهنگها را در اسپاتیفای انتقال دهیم؟</Link></li>
                                            <li><Link to={`${process.env.PUBLIC_URL}/blog/details?id=3`}>
                                                ویزا کارت چیست و انواع کارت های آن کدام اند و چه کاربردی دارند؟</Link></li>
                                            {/* <li><Link to={''} >سیم کارت بین المللی چیست و استفاده از آن چه مزایایی دارد؟</Link></li> */}
                                            {/* <li><Link to={''} >حواله بین الملل چه کار می‌کند؟</Link></li> */}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col mt-3">
                                <div className="sub-title">
                                    <div className="">
                                        <h4>دسترسی جدید</h4>
                                    </div>
                                    <div className="">
                                        <ul>
                                            <li><Link to={`${process.env.PUBLIC_URL}/products`} ><a href="#">خرید گیفت کارت</a></Link></li>
                                            <li><a href="#">خرید شماره مجازی</a></li>
                                            <li><Link to={`${process.env.PUBLIC_URL}/pages/rules`} ><a href="#">قوانین و مقررات</a></Link></li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="sub-title">
                                    <div className="">
                                        {/* <h4>تماس با ما</h4> */}
                                    </div>
                                    <div className="">
                                        <ul className="contact-list">
                                          
                                        <li><div className='d-flex' style={{justifyContent: 'center'}}>
                                           {/* <img src={Enamad}/> */}
                                           {/* <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/u?id=269442&Code='><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=269442&Code=' alt='' style={{cursor: 'pointer'}} Code=''/></a> */}
                                           <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=269442&Code=pF2QNBycXsuh1wg1fcPu'><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=269442&Code=pF2QNBycXsuh1wg1fcPu' alt='' style={{cursor:'pointer'}} Code='pF2QNBycXsuh1wg1fcPu'/></a>
                                           <img referrerpolicy='origin' id = 'rgvjesgtesgtoeukfukzoeuk' style ={{cursor: 'pointer'}} onClick={this.openWindow} alt = 'logo-samandehi' src = 'https://logo.samandehi.ir/logo.aspx?id=300868&p=qftilymalymaaqgwwlbqaqgw' /> </div></li>
                                            {/* <li><i className="fa fa-phone"></i>021-22322619</li>
                                            <li><i className="fa fa-envelope-o"></i><a
                                                href="#">ezcard724@gmail.com</a></li> */}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
              
            </footer>
        )
    }
}

export default FooterFour;